const initialState = {
  meeting: null,
  webex: null,
  videoMute: false,
  audioMute: false,
  localStream: null,
  remoteVideo: null,
  remoteAudio: null,
  teleconsultantData: null,
};

const actions = {
  WEBEX: 'meeting/WEBEX',
  MEETING: 'meeting/GET_MEETING_DETAILS',
  VIDEO_MUTE: 'meeting/VIDEO_MUTE',
  AUDIO_MUTE: 'meeting/AUDIO_MUTE',
  LOCAL_STREAM: 'meeting/LOCAL_STREAM',
  REMOTE_VIDEO: 'meeting/REMOTE_VIDEO',
  REMOTE_AUDIO: 'meeting/REMOTE_AUDIO',
  MEETING_RESET: 'meeting/MEETING_RESET',
  GET_PATIENT_MEETING_DETAILS: 'meeting/PATIENT_DETAILS',
};

export const WaitingRoomReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
  switch (action.type) {
    case actions.MEETING:
      return {
        ...state,
        meeting: action.payload,
      };
    case actions.WEBEX:
      return {
        ...state,
        webex: action.payload,
      };
    case actions.GET_PATIENT_MEETING_DETAILS:
      return {
        ...state,
        teleconsultantData: action.payload,
      };
    case actions.AUDIO_MUTE:
      return {
        ...state,
        audioMute: action.payload,
      };
    case actions.VIDEO_MUTE:
      return {
        ...state,
        videoMute: action.payload,
      };
    case actions.LOCAL_STREAM:
      return {
        ...state,
        localStream: action.payload,
      };
    case actions.REMOTE_VIDEO:
      return {
        ...state,
        remoteVideo: action.payload,
      };
    case actions.REMOTE_AUDIO:
      return {
        ...state,
        remoteAudio: action.payload,
      };
    case actions.MEETING_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const setIncomingMeetingDetails = (meetingDetails) => ({
  type: actions.MEETING,
  payload: meetingDetails,
});

export const setTeleconsultData = (meetingDetails) => ({
  type: actions.GET_PATIENT_MEETING_DETAILS,
  payload: meetingDetails,
});

export const setWebexData = (webexObject) => ({
  type: actions.WEBEX,
  payload: webexObject,
});

export const handleAudioMute = (muteStatus) => ({
  type: actions.AUDIO_MUTE,
  payload: muteStatus,
});

export const handleVideoMute = (muteStatus) => ({
  type: actions.VIDEO_MUTE,
  payload: muteStatus,
});

export const handleLocalStream = (localStream) => ({
  type: actions.LOCAL_STREAM,
  payload: localStream,
});

export const handleRemoteVideo = (remoteVideo) => ({
  type: actions.REMOTE_VIDEO,
  payload: remoteVideo,
});

export const handleRemoteAudio = (remoteAudio) => ({
  type: actions.REMOTE_AUDIO,
  payload: remoteAudio,
});

export const handleMeetingReset = () => ({
  type: actions.MEETING_RESET,
});

export default WaitingRoomReducer;
